export default function toastrConfig(toastrConfig) {
	angular.extend(toastrConfig, {
		allowHtml: true,
		closeButton: true,
		// why does setting the extendedTimeOut to zero make it show indefinitely?
		// No idea.  Timeouts are broken in this package.
		// https://github.com/Foxandxss/angular-toastr/issues/233
		timeOut: 8000,
		extendedTimeOut: 4000,
		tapToDismiss: false,
		progressBar: true,
		onShown: (toast) => {
			const toastElement = toast.el[0];
			// accessibility recommendations taken from the below resources
			// https://medium.com/@sheribyrnehaber/designing-toast-messages-for-accessibility-fb610ac364be
			// https://github.com/jackbsteinberg/std-toast
			if(toast.scope.toastType === "toast-error") {
				toastElement.setAttribute("role", "alert");
				toastElement.setAttribute("aria-live", "assertive");
			} else {
				toastElement.setAttribute("role", "status");
				toastElement.setAttribute("aria-live", "polite");
			}
		},
		positionClass: "toast-top-center",
		preventOpenDuplicates: true
	});
}
